
const newModel = () => {
    return {
        id: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        appId: null,
        appName: null,
        rolesGroupId: null,
        tenRolesGroup: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        id: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        appId: null,
        rolesGroupId: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        id: item.id,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        appId: item.appId,
        appName: item.appName,
        rolesGroupId: item.rolesGroupId,
        tenRolesGroup: item.tenRolesGroup,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        id: item.id,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        appId: item.appId,
        appName: item.appName,
        rolesGroupId: item.rolesGroupId,
        tenRolesGroup: item.tenRolesGroup,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        id: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        appId: null,
        rolesGroupId: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const quyenModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


